if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          mobileThumbnails: this.querySelector('[id^="GalleryMobileThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // Emit a load event to let the theme know the gallery is ready
        this.dispatchEvent(new Event('load'));
        this.classList.add('loaded');

        this.allMedia = this.elements.viewer.querySelectorAll('[data-media-id]');
        this.querySelector('.product__media-list').addEventListener('scroll', () => {
          this.allMedia.forEach((media) => {
            // If the media is in view horizontally select its thumbnail by more than 50%
            if (
              media.getBoundingClientRect().left < window.innerWidth / 2 &&
              media.getBoundingClientRect().right > window.innerWidth / 2
            ) {
              const thumbnail = this.elements.mobileThumbnails.querySelector(`[data-target="${media.dataset.mediaId}"]`);
              this.setActiveMobileThumbnail(thumbnail);
              this.updateMobileMediaScroll(media);
            }
          });
        })
        
      }

      updateMobileMediaScroll(media) {
        // Wait til the scroll event is done
        this.scrollTimeout && clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          if (!media.matches('.product__media-item')) media = media.closest('.product__media-item');
          this.setActiveMobileMedia(media.dataset.mediaId);
        }, 100);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveMobileMedia(mediaId) {
        if (this.currentMediaId === mediaId) return;
        this.currentMediaId = mediaId;
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.playActiveMedia(activeMedia);

      }



      setActiveMediaByVariant(mediaId, variant) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        // get all the thumbnails 
        setTimeout(() => {
          const thumbnails = this.elements.thumbnails.querySelectorAll('[data-target] button');
          const mobileThumbnails = this.elements.mobileThumbnails.querySelectorAll('[data-target] button');
          for (const thumbnail of thumbnails) {
            try {
              if (thumbnail.dataset.mediaOptions) {
                const [index, value] = JSON.parse(thumbnail.dataset.mediaOptions);
                const thumbnailLi = thumbnail.closest('li');
                thumbnailLi.classList.toggle('hidden', value.toLowerCase() !== variant.options[index].toLowerCase());
                const media = document.querySelector(`.product__media-item[data-media-id="${thumbnailLi.dataset.target}"]`);
                media.classList.toggle('hidden', value.toLowerCase() !== variant.options[index].toLowerCase());
                
              }
            } catch (e) {
              console.error(e);
            }
          }
          for (const mobileThumbnail of mobileThumbnails) {
            try {
              if (mobileThumbnail.dataset.mediaOptions) {
                const [index, value] = JSON.parse(mobileThumbnail.dataset.mediaOptions);
                const thumbnailLi = mobileThumbnail.closest('li');
                thumbnailLi.classList.toggle('hidden', value.toLowerCase() !== variant.options[index].toLowerCase());
              }
            }
            catch (e) {
              console.error(e);
            }
          }
        });
        
      }
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
      setActiveMobileThumbnail(thumbnail) {
        if (!this.elements.mobileThumbnails || !thumbnail) return;

        this.elements.mobileThumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.mobileThumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.mobileThumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false, true);
        if (deferredMedia?.getAttribute("loaded")) {
          deferredMedia.querySelector("video, model-viewer, iframe")?.play();
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
